import createInformationModal from './createInformationModal';
import { ID_TILL_CEILING_INFO } from '../../utils/dom-element-ids';

// Configuration for Till Ceiling Information Modal
const TILL_CEILING_MODAL_CONFIG = {
  titleKey: 'lbl.till-ceiling',
  informationList: [
    {
      item: 'lbl.till-ceiling',
      definition: 'lbl.till-ceiling-definition',
    },
  ],
  iconId: ID_TILL_CEILING_INFO,
  wrapperClassName: 'pb3-sm',
};

// Generate component from configuration
const TillCeilingInformationModal = createInformationModal(TILL_CEILING_MODAL_CONFIG);

export default TillCeilingInformationModal;
